export default "__VITE_ASSET__BNon9Iix__"